import { render } from "./CreateLit.vue?vue&type=template&id=a464e388&scoped=true"
import script from "./CreateLit.vue?vue&type=script&lang=js"
export * from "./CreateLit.vue?vue&type=script&lang=js"

import "./CreateLit.vue?vue&type=style&index=0&id=a464e388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a464e388"]])

export default __exports__